import 'fomantic-ui-less/definitions/modules/transition';
import 'fomantic-ui-less/definitions/modules/dropdown';
import isEmpty from 'lodash/isEmpty';
import {SWF_FORM_PREFIX} from '../../Common/constants';

export default class FormSelectNodeView {
    constructor(node, view, getPos) {
        this.view = view;
        this.getPos = getPos;
        this.node = node;

        const name = `${SWF_FORM_PREFIX}${node.attrs.name || ''}`;
        const id = `${SWF_FORM_PREFIX}${node.attrs.id || ''}`;

        this.dropdown = document.createElement('div');
        this.dropdown.className = `ui disabled selection dropdown${node.attrs.multiple ? ' multiple' : ''}`;
        if (node.attrs.readOnly) {
            this.dropdown.setAttribute('readonly', '');
        }
        if (node.attrs.multiple) {
            this.dropdown.setAttribute('multiple', '');
        }
        this.dropdown.disabled = true;
        this.dropdown.insertAdjacentHTML('afterbegin', `
            <input type="hidden" id="${id}" name="${name}">
            <i class="dropdown icon"></i>
            <div class="default text"></div>
        `);

        this.dom = this.dropdown;

        const dropdownSettings = {
          allowAdditions: node.attrs.allowAdditions,
          clearable: node.attrs.clearable
        }

        const settings = node.attrs?.settings;
        if (!isEmpty(settings?.api?.url)) {
          dropdownSettings.apiSettings = {
            url: settings.api.url,
            method: settings.api?.method || 'GET'
          };
        } else if (!isEmpty(settings?.values)) {
          dropdownSettings.values = settings.values
        }

        $(this.dropdown).dropdown(dropdownSettings);
    }

    ignoreMutation() {
        return true;
    }

    destroy() {
        $(this.dropdown).dropdown('destroy');
        this.dom.remove();
        delete this.dom;
    }
}